import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ButtonGroup from '@mui/material/ButtonGroup';

export default function IncDecQuantity(props: any) {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				'& > *': {
					m: 1,
				},
			}}
		>
			<span>{props.totalQuantity}</span>
			<ButtonGroup size="small" aria-label="small button group">
				{['-', '+'].map((action: string) => {
					return <Button key={action}
						disabled={(action === '-' && props.totalQuantity === 1) || props.disabled}
						onClick={() => props.onIncDecQuantityClick(props.item, action)}>
						{action}
					</Button>
				})}
			</ButtonGroup>
		</Box>
	);
}
